<template>
  <v-container>
    <v-layout justify-center class="mt-5">
      <v-flex shrink>
        <v-grid-loader loading color="purple" />
      </v-flex>
    </v-layout>
    <v-layout v-if="message" class="mt-5" justify-center>
      <v-flex class="grey--text font-weight-light title" shrink>{{ message }}</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VGridLoader from "vue-spinner/src/GridLoader";

export default {
  components: {
    VGridLoader
  },
  props: {
    message: {
      type: String
    }
  }
};
</script>